import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';


@Component({
  selector: 'app-single-employer-list',
  templateUrl: './single-employer-list.component.html',
  styleUrl: './single-employer-list.component.css'
})
export class SingleEmployerListComponent implements OnInit {
  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  interests = [];
  opening;
  company = JSON.parse(localStorage.getItem('company_' + this.businessID));
  contacted_by = [];
  routeId = this.route.snapshot.params.id;
  currentUserId = this.authService.getTokenData().userID
  list;
  original_description = "";
  is_saved = false;
  storable_profile;
  shared_view = true;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.fetchSingleList();
    console.log(this.currentUserId)
    console.log(this.company)
  }

  fetchSingleList() {
    this.http.get(environment.EMPLOYER_LIST + '/'+ this.routeId, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log('company interests', res.message)
          this.list = res.message[0];
          this.original_description = this.list.description;
          console.log(this.list.name)
          if(this.currentUserId == this.list.employerID){
            this.shared_view = false;
          } 

          setTimeout(() => {
          var sorting_element = (<HTMLSelectElement>document.getElementById('sorting'));
          var value = this.list.can_be_seen_by_others_in_same_business == true ? 'true' : 'false';
          sorting_element.value = value;
          }, 200)

        }
        else {
          console.log("Error while finding status :: ", res);
          this.list = {};
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  routeProfile(data){
    this.router.navigate(['/'+this.businessID + '/wishlist/profile-opened/businessInterest/like/' + data._id])

  }

  openRemoveProfile(data){

    this.storable_profile = data;

    document.getElementById('remove-profile').click();

  }

  fetchPublicProfile(data){


    this.http.get(environment.VALIDATE_HEADHUNTING_PROFILE + '/' + data._id, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {

          var obj = {
            profile: res.message[0]
          }

          var languages_obj_array = obj.profile.languages;
          var display_lang_str = "";
          var display_school_str = "";

          if(languages_obj_array.length > 0){
            for (let i = 0; i < languages_obj_array.length; i++) {
              var lang = languages_obj_array[i];
              console.log(lang);
              display_lang_str += lang.name_fi + ', ';
            }

                      //remove last comma
          display_lang_str = display_lang_str.slice(0, -2);
          obj.profile.display_lang = display_lang_str;

          }

          if(obj.profile.schools && obj.profile.schools.length > 0){
            for (let i = 0; i < obj.profile.schools.length; i++) {
              var school = obj.profile.schools[i];
              console.log(school);
              display_school_str += school.name + ', ';
            }

            //remove last comma
            display_school_str = display_school_str.slice(0, -2);
            obj.profile.display_school = display_school_str;

          }


          this.opening = obj;

          document.getElementById('oc-profile').click();
          
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  goBack(){
    window.history.back();
  }

  saveDescription(){
    console.log(this.list.description);
    var update_data = {
      type: 'description',
      value: this.list.description  
    }

    this.editList(update_data);
  }

  saveRights(){
    var sorting_element = (<HTMLSelectElement>document.getElementById('sorting')).value;

    var update_data = {
      type: 'rights',
      value: sorting_element == 'true' ? true : false  
    }

    console.log(update_data);
    this.editList(update_data);
  }



  editList(data){

    this.http.put(environment.EMPLOYER_LIST + '/'+ this.routeId, data, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res.message)
          this.is_saved = true;
          this.closeSaved();
        }
        else {
          console.log("Error while finding status :: ", res);
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })

  }

  closeSaved(){
    setTimeout(() => {
      this.is_saved = false;
    },5000)
  }

  removeItemFromList() {

    var req = {
      profileID: this.storable_profile._id,
      lists: [this.routeId]
    }
    console.log(this.storable_profile);
    this.http.post(environment.REMOVE_PROFILE_FROM_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          //Remove all lists from already_in_list
          //Remove profile from list.profiles
          this.fetchSingleList();
          //Now open confirmation popup
          document.getElementById('close-remove-profile').click();
          document.getElementById('remove-profile-confirmation').click();

        }
        else {
          console.log('buu');
          alert('Virhe henkilöä poistaessa listalta');
        }

      }, (err: any) => {

      }
    )

  }

  removeList(){
    this.http.delete(environment.EMPLOYER_LIST + '/'+ this.routeId, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          document.getElementById('close-remove-list').click();
          document.getElementById('list-removed').click();
         this.goBack() 
          
        }
        else {
          console.log("Error while finding status :: ", res);
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  sendMessage() {

    var profilePicture;
    console.log(this.opening)
    profilePicture = this.opening.profile['profilePicture'];

    var req = {
      openingID: null,
      firstName: this.opening.profile.firstName,
      mdType: {},
      logo: this.opening.logo,
      userID: this.opening.profile._id,
      type: 'businessInterest',
      businessID: this.businessID,
      profilePicture: profilePicture,
    }

    this.http.post(environment.MESSAGE_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.routeMessages(res.message[0]._id)
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  routeMessages(id) {
    console.log(id);
    localStorage.setItem('ACTIVE_MSG_LIST', JSON.stringify(id));
    this.router.navigate(['/' + this.businessID + '/messages']);
  }
}
